import { useState, useEffect } from 'react';
import { properties as appProperties } from 'AppData';
import { pathIcono} from './SubirArchivoData';
import { properties as propertiesMultimedia} from 'components/pages/aporteDocumentacion/AporteDocumentacionData';

const useOperations = () => {
    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    const [mostrarTexto, setMostrarTexto] = useState(false);
    const [configCargada, setConfigCargada] = useState(false);

    useEffect(() => {
            const checkConfig = () => {
                const cargada =
                    propertiesMultimedia.ALLOWEDIMAGEFORMATS &&
                    propertiesMultimedia.ALLOWEDVIDEOFORMATS &&
                    propertiesMultimedia.ALLOWEDMIMETYPES;

                setConfigCargada(!!cargada);
            };

            checkConfig();
    }, []);

    const updateFormat = () => {
        if (window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    }

    /**
     * @function cerrarPopUpPdf Corta el texto que aparece en el dropzone
     */
     const cortarTexto = (texto) =>{
        let numCaracteres = isPhoneVersion ? 40 : 20;
        return (texto.length <= numCaracteres) ? (texto) : (texto.substring(0, numCaracteres) + '...');
    };

    /**
     * @function mostrarTextoEntero Abre o cierra el acordeon que muestra el texto
     */
     const mostrarTextoEntero = () =>{
        setMostrarTexto(!mostrarTexto);
    };


    const getImageTypes = () =>
        propertiesMultimedia.ALLOWEDIMAGEFORMATS?.split(',').map(ext => ext.toLowerCase().trim()) ?? [];

    const getVideoTypes = () =>
        propertiesMultimedia.ALLOWEDVIDEOFORMATS?.split(',').map(ext => ext.toLowerCase().trim()) ?? [];

    const getAllowedMimeTypes = () =>
        propertiesMultimedia.ALLOWEDMIMETYPES?.split(',').map(m => m.trim()) ?? [];

    const getMaxFileSize = (extension, tamMaxArchivo) => {
        const ext = extension.toLowerCase();
        const imageTypes = getImageTypes();
        const videoTypes = getVideoTypes();
        const maxImageSize = parseInt(propertiesMultimedia.MAXIMAGESIZE);
        const maxVideoSize = parseInt(propertiesMultimedia.MAXVIDEOSIZE);

        if (imageTypes.includes(ext)) return maxImageSize;
        if (videoTypes.includes(ext)) return maxVideoSize;
        return tamMaxArchivo * 1000000;
    };

    const buildAcceptAttribute = (formato) => {
        const imageTypes = getImageTypes();
        const videoTypes = getVideoTypes();
        return formato
            .map(ext => ext.toLowerCase().trim())
            .filter(ext =>
                imageTypes.includes(ext) || videoTypes.includes(ext) || ext === '.pdf'
            );
    };

    const getMimeType = (ext) => {
        const extension = ext.toLowerCase();
        const imageTypes = getImageTypes();
        const videoTypes = getVideoTypes();
        const allowedMimeTypes = getAllowedMimeTypes();

        const imageMimeMap = {
            '.jpeg': 'image/jpeg',
            '.jpg': 'image/jpeg',
            '.png': 'image/png',
            '.bmp': 'image/bmp',
            '.webp': 'image/webp',
        };

        const videoMimeMap = {
            '.mov': 'video/quicktime',
            '.mpeg': 'video/mpeg',
            '.mpg': 'video/mpeg',
            '.mp4': 'video/mp4',
            '.avi': '.avi',
            '.wmv': '.wmv',
        };

        if (extension === '.pdf') {
            return allowedMimeTypes.includes('application/pdf') ? 'application/pdf' : null;
        }

        if (imageTypes.includes(extension)) {
            const mime = imageMimeMap[extension];
            return allowedMimeTypes.includes(mime) ? mime : null;
        }

        if (videoTypes.includes(extension)) {
            const mime = videoMimeMap[extension];
            return allowedMimeTypes.includes(mime) ? mime : null;
        }

        return null;
    };

    const getPreviewImage = (fileExtension) => {
        const ext = fileExtension.toLowerCase();
        const imageTypes = getImageTypes();
        const videoTypes = getVideoTypes();

        if (ext === '.pdf') return pathIcono.PATH_IMG_PDF;
        if (imageTypes.includes(ext)) return pathIcono.PATH_IMG_FOTO;
        if (videoTypes.includes(ext)) return pathIcono.PATH_IMG_VIDEO;
        return pathIcono.PATH_IMG_PDF;
    };

    const getSafeFileName = (file) => {
        if (!file) return undefined;
        return file.name || file.file?.name || file.file?.path;
    };

    const getTipoSubido = (mimeType) => {
        if (mimeType.startsWith('image/')) return 'imagen';
        if (mimeType.startsWith('video/') || mimeType.includes('.avi') || mimeType.includes('.wmv')) return 'video';
        return 'pdf';
    };

    const getTipoEsperado = (texto) => {
        const lower = texto.toLowerCase();
        if (lower.includes('video')) return 'video';
        if (lower.includes('foto')) return 'imagen';
        return 'pdf';
    };

    return {
        isPhoneVersion,
        updateFormat,
        cortarTexto,
        mostrarTextoEntero,
        mostrarTexto,
        getMaxFileSize,
        buildAcceptAttribute,
        getMimeType,
        getPreviewImage,
        getSafeFileName,
        getTipoSubido,
        getTipoEsperado,
        configCargada
    };
};

export default useOperations;